
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.333 16.667a2.333 2.333 0 004.667 0V2.333a2.333 2.333 0 00-4.667 0v14.334zm-9.333 0a2.333 2.333 0 004.667 0V2.333a2.333 2.333 0 00-4.667 0v14.334z","fill":"#263238"}})])
          )
        }
      }
    